import { defaultDsgvoRequest, dsgvoRequestSchema, DsgvoRequestType, useCreateDsgvoRequestMutation } from '@/api/dgsvoRequest';
import { useCreateDetail } from '@/components/detail/CreateDetailRecord';
import FormDebug from '@/components/FormDebug';
import ScoutIdAutocompleteField from '@/components/ScoutIdAutocompleteField';
import { DevTool } from '@hookform/devtools';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'i18next';
import { enqueueSnackbar } from 'notistack';
import { Controller, FormProvider } from 'react-hook-form';



export const Route = createFileRoute(
    '/_auth/organization_/$organizationUuid/dsgvoRequest',
)({
    component: DsgvoRequestComponent,
})

function DsgvoRequestComponent() {
    const params = Route.useParams()

    const createMutation = useCreateDsgvoRequestMutation(params.organizationUuid,
        () => {
            enqueueSnackbar(t('action.created', { entity: t('entity.dsgvoRequest') }), { variant: 'success' });
        },
        () => {
            enqueueSnackbar(t('error.default'), { variant: 'error' });
        },
    )

    const onSubmit = (data: DsgvoRequestType) => {
        createMutation.mutate({ ...data, uuid: '' })
    }

    const createDetail = useCreateDetail<DsgvoRequestType>({
        onSubmit,
        resolver: yupResolver<DsgvoRequestType, any, any>(dsgvoRequestSchema),
        defaultValues: {
            ...defaultDsgvoRequest,
            organization: {
                uuid: params.organizationUuid,
            },
        },
        title: t('action.new', { entity: t('entity.membershipRequest') }),
    })
    return (
        (<>
            <FormProvider {...createDetail.form}>
                <form onSubmit={createDetail.form.handleSubmit(createDetail.detailProps.onSubmit)}>

                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        <ScoutIdAutocompleteField
                            name="affectedMember"
                            defaultValue={''}
                            control={createDetail.form.control}
                            errors={createDetail.form.formState.errors}
                        ></ScoutIdAutocompleteField>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        <FormControl fullWidth variant="standard">
                            <InputLabel id="scoutstate-select-label">
                                {t('property.dsgvoRequest.reason')}
                            </InputLabel>
                            <Controller
                                name="reason"
                                control={createDetail.form.control}
                                defaultValue="Recht auf Löschung (DSGVO Artikel 17)"
                                render={({ field }) => (
                                    <Select labelId="reason-select-label" {...field}>
                                        <MenuItem key="Recht auf Löschung (DSGVO Artikel 17)" value="Recht auf Löschung (DSGVO Artikel 17)">
                                            {'Recht auf Löschung (DSGVO Artikel 17)'}
                                        </MenuItem>
                                        <MenuItem key="Recht auf Einschränkung der Verarbeitung (DSGVO Artikel 18)" value="Recht auf Einschränkung der Verarbeitung (DSGVO Artikel 18)">
                                            {'Recht auf Einschränkung der Verarbeitung (DSGVO Artikel 18)'}
                                        </MenuItem>
                                        <MenuItem key="Recht auf Datenübertragbarkeit (DSGVO Artikel 20)" value="Recht auf Datenübertragbarkeit (DSGVO Artikel 20)">
                                            {'Recht auf Datenübertragbarkeit (DSGVO Artikel 20)'}
                                        </MenuItem>
                                        <MenuItem key="Widerspruchsrecht (DSGVO Artikel 21)" value="Widerspruchsrecht (DSGVO Artikel 21)">
                                            {'Widerspruchsrecht (DSGVO Artikel 21)'}
                                        </MenuItem>
                                    </Select>
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        <TextField
                            defaultValue={defaultDsgvoRequest.message}
                            required
                            {...createDetail.form.register('message')}
                            label={t('property.dsgvoRequest.message')}
                            helperText={createDetail.form.formState.errors.message?.message}
                        />
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Button type="submit" variant="contained" disabled={import.meta.env.VITE_DEBUG !== 'true' && (!createDetail.form.formState.isDirty || !createDetail.form.formState.isValid)}>
                                {t('action.send')}
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <FormDebug dirty={createDetail.form.formState.isDirty} valid={createDetail.form.formState.isValid} errors={createDetail.form.formState.errors} value={undefined} />
                    </Grid>
                </form>
            </FormProvider>
            {import.meta.env.VITE_DEBUG === 'true' &&
                <DevTool control={createDetail.form.control} />
            }


        </>)
    );
}
